// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1tZWc","bigColWidth":"Table_bigColWidth__r3ijc","biggerColWidth":"Table_biggerColWidth__3vbfg","row":"Table_row__3xH4z","col":"Table_col__b_rey"};